import "toasted-notes/src/styles.css"; // optional styles
import {
  GET_ALL_INITIAL_PRODUCTS,
  GET_ALL_PRODUCTS,
  GET_ALL_PRODUCTS_FAIL,
  GET_ALL_PRODUCTS_SUCCESS,
  GET_SINGLE_PRODUCT,
  GET_SINGLE_PRODUCT_FAIL,
  GET_SINGLE_PRODUCT_SUCCESS,
} from "../../actions/ecommerce/types";

const initialState = {
  data: [],
  params: null,
  allData: [],
  totalPages: 0,
  filteredData: [],
  totalRecords: 0,
  product_loading: false,
  sortIndex: [],
  productDetail: {},
};

const getIndex = (arr, arr2, arr3, params = {}) => {
  if (arr2.length > 0) {
    let startIndex = arr.findIndex((i) => i.id === arr2[0].id) + 1;
    let endIndex = arr.findIndex((i) => i.id === arr2[arr2.length - 1].id) + 1;
    let finalArr = [startIndex, endIndex];
    return (arr3 = finalArr);
  } else {
    let finalArr = [arr.length - parseInt(params.perPage), arr.length];
    return (arr3 = finalArr);
  }
};

const product = (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case GET_ALL_PRODUCTS:
      return {
        ...state,
        product_loading: true,
      };
    case GET_ALL_PRODUCTS_SUCCESS:
      return {
        ...state,
        data: action.data,
        totalPages: action.totalPages,
        params: action.params,
        next: action.next,
        previous: action.previous,
        sortIndex: getIndex(
          state.allData,
          action.data,
          state.sortIndex,
          action.params
        ),
      };
    case GET_ALL_INITIAL_PRODUCTS: //initial data
     
      return {
        ...state,
        loading: false,
        allData: action.data.results,
        totalPages: action.totalPages,
        next: action.data.next,
        previous: action.data.previous,
        sortIndex: getIndex(action.data, state.data, state.sortIndex),
      };
    case GET_ALL_PRODUCTS_FAIL:
      return { ...state, loading: false, failed: true };

    case GET_SINGLE_PRODUCT:
      return { ...state, loading: true };
    case GET_SINGLE_PRODUCT_SUCCESS:
      return { ...state, loading: false, productDetail: action.payload };
    case GET_SINGLE_PRODUCT_FAIL:
      return { ...state, loading: false };
    default: {
      return state;
    }
  }
};

export default product;
